// icons that are circles (the actual "balls") - these get special styling ::
export const ROUND_SPORT_BALL_ICONS: string[] = [
  'baseball',
  'basketball',
  'soccer',
  'futsal',
  'softball',
  'tennis',
  'volleyball'
]

export const ROUND_SPORT_ICON_CLASS: string = 'se-team-avatar__round-sport-icon'

export function isRoundSportBallIcon(icon: string): boolean {
  return (ROUND_SPORT_BALL_ICONS.indexOf(icon) !== -1)
}
